import React from 'react';

import Logo from "../../assets/logo/come-to-be-coaching-logo.png";
import ICFlogo from "../../assets/logo/ICF-logo.png";

const Loader = () => {
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh', // Full viewport height
    backgroundColor: '#f8f9fa', // Optional: Add background color if desired
  };

  return (
    <div style={containerStyle}>
      {/* <div style={wrapperStyle}>
        <img src={Logo} alt="CTB Logo" style={logoStyle} />
        <img src={ICFlogo} alt="ICF Logo" style={logoStyle} />
      </div> */}
      <div
        style={{
          padding: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        <img
          style={{ height: "60px" }}
          src={ICFlogo}
          alt="ICF Logo"
          data-aos="fade"
        />
        <img style={{ height: "70px" }} src={Logo} alt="CTB Logo" data-aos="fade" />
      </div>
    </div>
  );
};

export default Loader;
